<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202506_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202506_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>夏こそ美肌つくりをサボらないで</span><br>乾燥肌対策の鍵は「うるおいバリア」</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">キレイな肌を目指すなら、夏こそ勝負</h3>
        <p class="mb-3">汗をかいているのに肌がつっぱる。</p>
        <p class="mb-3">冷房のきいた部屋で長時間過ごすと、夕方には肌がカサつく。</p>
        <p class="mb-3">そんなこと、ありませんか？</p>
        <p class="mb-3">夏は皮脂や汗で一見うるおっているように思いがちですが、実は肌内部の水分が不足している「インナードライ」状態に陥りやすい季節です。</p>
        <p>さらに強い紫外線やエアコンの乾燥が重なることで、肌の角層バリアが乱れ、敏感肌トラブルの引き金にもなりやすくなります。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202506_02.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202506_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">こんな方は「夏の隠れ乾燥」に要注意</h3>
        <ul class="mb-3">
          <li>日中はテカるのに、夕方になるとつっぱる</li>
          <li>化粧のノリが悪い</li>
          <li>ほおはカサつくのにTゾーンはベタつく</li>
          <li>なんとなく肌が敏感になっている気がする</li>
        </ul>
        <p class="mb-3">ひとつでも当てはまる方は、夏の「隠れ乾燥」＝インナードライが進行しているサインかもしれません。</p>
        <p class="mb-3">放っておくとバリア機能が弱まり、毛穴の目立ちやくすみ、肌荒れといった肌悩みにつながることも。</p>
        <p>「夏は保湿いらないかも」と思っている方ほど、しっかりと水分補給と保湿を意識しましょう。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">角層バリアを守る夏の基本ステップ</h3>
        <p class="mb-3">夏こそ「肌の土台＝角層バリア」を整えるスキンケアが大切です。</p>
        <ul class="mb-3">
          <li>洗顔はゴシゴシせず、やさしく余分な皮脂を落とす</li>
          <li>化粧水でたっぷり水分を与える</li>
          <li>美容液で必要な保湿成分をプラス</li>
          <li>乳液・クリームで水分を閉じ込める</li>
        </ul>
        <p class="mb-3">最近注目されるセラミドやヒト型セラミドなどは、角層のバリア機能をサポートする成分として話題です。</p>
        <p>「うるおいバリア」を意識してステップケアを続けることが、未来の肌への投資につながります。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202506_04.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202506_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">紫外線ダメージを受けにくい肌づくり</h3>
        <p class="mb-3">夏の大敵である紫外線は、シミ・乾燥だけでなく肌バリアそのものを弱らせる要因です。</p>
        <p class="mb-3">SPF入り下地や日焼け止めで紫外線を防ぐのはもちろん、紫外線を浴びたあとは敏感になりやすい肌を保護する低刺激で高保湿なアイテムでケアを。</p>
        <p>紫外線でダメージを受けた角層は、保湿と鎮静ケアを早めに行うことで、敏感肌トラブルを最小限にとどめることができます。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">敏感肌を守る低刺激のスキンケア選び</h3>
        <p class="mb-3">紫外線や冷房の刺激でゆらぎやすい夏の肌は、ちょっとした刺激にも敏感に反応しやすくなります。</p>
        <p class="mb-3">香料やアルコールを控えめにした低刺激処方のスキンケアを選ぶことで、負担をかけずにうるおいを補給しましょう。</p>
        <p class="mb-3">敏感肌に寄り添う処方でありながら有効成分を配合したアイテムを多く展開するマナビス化粧品に。</p>
        <p>夏の肌変化に対応しつつ<strong>「攻めすぎない、でも確実に守る」</strong>そんなスキンケアが支持されています。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202506_06.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202506_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">マナビス化粧品で始める“うるおいバリア”習慣</h3>
        <p class="mb-3">マナビス化粧品のステップスキンケアは、紫外線や乾燥ダメージから肌を守りながら、うるおいを与えて閉じ込めることにこだわった処方。</p>
        <p class="mb-3">薬用ローションや美容液、クリームを組み合わせることで「水分を与える・留める・守る」の3段階の保湿ケアが実現します。</p>
        <p class="mb-3">敏感肌でも使えるやさしさと確かな手応えを両立し、夏のインナードライ対策にも頼れる存在。</p>
        <p>毎日のスキンケアで肌に寄り添い、未来の美しさを一緒に育てていきましょう。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3 fs-2">“うるおいバリア”は未来の肌への投資</p>
        <p class="mb-3">毎日のスキンケアは、肌を整えるだけでなく、自分と向き合う大切な時間です。</p>
        <p class="mb-3">どんな日も、どんな気持ちの日も。</p>
        <p class="mb-3">肌に寄り添って守ってくれる存在があることは、未来の自分への小さな投資ともいえます。</p>
        <p class="mb-3">「今日の自分にやさしく、そして未来の自分に誇れる肌へ」</p>
        <p>この夏、マナビス化粧品の“うるおいバリア”習慣で、<br>その変化をあなたの肌で確かめてみてください。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>